import ClipText from "@components/ClipText/ClipText";
import Image from "@components/Image";
import cx from "classnames";
import React from "react";
import styles from "./Experiences.module.scss";
import { useTranslationContext } from "@providers/TranslationProvider";
import Button from "@components/Button";
import Link from "@components/Link";
import _ from "lodash";

interface Props {
  data: {
    image: {
      src: string;
      alt: string;
    } | null;
    title: string;
    content: string | React.ReactNode;
    // actionMore: string | React.ReactNode;
    button?: {
      href: string;
      label: string;
    };
  };
  className: string | { [key: string]: string };
}

export default function Item({ data, className }: Props) {
  const { i18n } = useTranslationContext();

  return (
    <div className={cx("slide-item animated", styles.item, className)}>
      <Link href={_.get(data, "button.href")}>
        {data?.image?.src && (
          <Image
            wrapperProps={{ className: cx(styles.image) }}
            src={data.image.src}
            alt={data.image.alt || ""}
            layout="fill"
            objectFit="cover"
          />
        )}
        <ClipText fixedRows rows={2} className={cx(styles.title)}>
          {data.title}
        </ClipText>
        <ClipText fixedRows rows={4} className={cx(styles.content)}>
          {data.content}
        </ClipText>
        <Button
          type="icon"
          suffix="shape-arrow"
          className={cx(styles.actionMore)}
          label={i18n.t(data?.button?.label)}
        />
      </Link>
    </div>
  );
}
